<template>
<div v-if="!registrationIsOpen" class="mt-3 mb-3 text-center">
      Регистрация не доступна ... 😥
</div>
<div v-else-if="!isNewTeamButtonClicked">
    <br>
    <my-button class="w-100" @click="isNewTeamButtonClicked = true">Создать новую команду</my-button>
    <br>
    <my-button class="w-100" @click="redirectToLogin">Играть в существующей команде</my-button>
    <br>
</div>
<form v-else @submit.prevent="submitForm">
    <vue-select
        v-if="event.united && event.unitedEvents"
        label="Место"
        :options="getUnitedEventsOptions()"
        v-model="selectedEvent"
        required
    />

    <my-input
      :disabled="regFormResponse"
      required
      label="Название команды"
      v-model="regForm.teamTitle"
    />
    <my-input
      required
      :disabled="regFormResponse"
      :label="`Кол-во участников (не больше ${maxPlayerInTeam})`"
      v-model="regForm.participantCount"
      type="number"
      :max="maxPlayerInTeam"
      min="1"
    />
    <my-input
      :disabled="regFormResponse"
      required
      label="Ваше имя"
      v-model="regForm.firstName"
    />
    <my-input
      required
      :disabled="regFormResponse"
      ref="phoneInput"
      phone-input
      label="Телефон для связи"
      v-model="regForm.phone"
      type="tel"
      data-tel-input
      autocomplete="tel"
      maxlength="18"
    />
    <div v-if="error" class="text-danger">{{error}}</div>
    
    <div
      class="policy-box"
      :class="{
        'policy-box--error': policyError,
        'policy-box--active': isPolicyAccepted
      }"
      @click="isPolicyAccepted = !isPolicyAccepted"
    >
      <div class="policy-checkbox">
        <svg
          v-if="isPolicyAccepted"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>

      <div class="policy-text">
        Ознакомлен и принимаю условия
        <a href="#" @click.prevent="showPolicyModal = true">
          политики обработки персональных данных
        </a>
      </div>
    </div>

    <div
      class="policy-box padding"
      :class="{
        'policy-box--error': personalDataError,
        'policy-box--active': isPersonalDataAccepted
      }"
      @click="isPersonalDataAccepted = !isPersonalDataAccepted"
    >
      <div class="policy-checkbox">
        <svg
          v-if="isPersonalDataAccepted"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      </div>

      <div class="policy-text">
        Согласен на обработку
        <a href="#" @click.prevent="showPersonalDataModal = true">
          персональных данных
        </a>
      </div>
    </div>
    
    <my-button type="button" cls="blue" class="w-100" v-if="regFormResponse">Вы зарегистрированы</my-button>
    <my-button type="button" class="w-100" v-else-if="loading" cls="purple">Регистрируем <pre-loader class="ms-4" no-width no-height sm/></my-button>
    <my-button class="w-100" v-else type="submit" :disabled="!canSubmitForm" :cls="canSubmitForm ? '' : 'hollow'" :class="{'disabled': !canSubmitForm}">Зарегистрироваться</my-button>
  </form>
  <teleport to="#app">
    <my-modal ref="finalReg">
      <div class="fs-5 mb-3">Ваша команда <strong>{{regForm.teamTitle}}</strong> успешно зарегистрирована!</div>
      <div v-if="codeSended">
        <p> Если хотите войти в кабинет регистрации команды,</p>
        <p v-if="codeSendBy==='whatsapp'" class="info-note ">введите 4-х значный код, отправленный вам в WhatsApp.</p>
        <p v-else-if="codeSendBy==='flash_call'" class="info-note ">введите последние 4-ре цифры номера входящего вызова.</p>
        <p v-else class="info-note ">введите 4-х значный код, отправленный вам на номер <strong>{{regForm.phone}}</strong>.</p>
        <my-input
          ref="inputCode"
          v-on:keyup.enter="sendValidateCode"
          v-model="validateCode"
          type="number"
          maxlength="4"
          pattern="\d{4}"
          autocomplete="off"
          label="Код"
        />
      </div>
      <my-button cls="hollow" class="w-100" @click="$router.push('/')" > На главную</my-button>
    </my-modal>
    <my-modal ref="inviteToLogin">
      <p class="fs-5 my-3">Команда с таким названием уже существует!</p>
      <p class="my-3">Если эта команда создана вами, тогда нужно авторизоваться, чтобы вы могли её зарегистрировать на игру.</p>
      <my-button class="w-100" @click="$router.push({name:'login', query: {from: $route.path}})">
        Авторизоваться
      </my-button>
    </my-modal>
  </teleport>

<transition name="fade">
  <div
    v-if="showPolicyModal"
    class="policy-modal-overlay"
    @click="showPolicyModal = false"
  >
    <div
      class="policy-modal"
      @click.stop
    >

      <button
        class="policy-modal-close"
        @click="showPolicyModal = false"
      >
        ×
      </button>

      <h2 class="policy-modal-title">
        Политика обработки персональных данных
      </h2>

      <div class="policy-modal-content">

          <p><b>Политика обработки персональных данных</b></p>

          <p><b>1. Общие положения</b></p>

          <p>1.1. Настоящая Политика обработки персональных данных (далее — Политика) разработана в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — Закон о ПДн).</p>

          <p>1.2. Политика определяет порядок обработки персональных данных (далее — ПДн) и меры по обеспечению их безопасности оператором.</p>

          <p>1.3. Оператор обрабатывает ПДн на законных основаниях, в том числе на основании согласия субъекта ПДн.</p>

          <p><b>2. Принципы обработки ПДн</b></p>

          <p>2.1. Обработка осуществляется в целях, заранее определённых и явных, и не допускается без ПДн, несовместимая с этими целями.</p>

          <p>2.2. Обработка ограничена достижением целей, точностью и достаточностью ПДн для этих целей.</p>

          <p><b>3. Категории и цели обработки ПДн</b></p>

          <p>3.1. Оператор обрабатывает следующие категории ПДн:</p>

          <p>Общие ПДн: ФИО (имя, фамилия, отчество по желанию), номер телефона, идентификатор профиля ВКонтакте (VK ID) — для создания учётной записи, аутентификации и связи с пользователем (далее — Цель 1).</p>

          <p>Технические данные: cookies, IP-адрес, данные о поведении на сайте — для аналитики с использованием Яндекс.Метрика (далее — Цель 2).</p>

          <p>3.2 Необходимые cookies: session (сессия), csrf_token (безопасность) — для работы сайта без согласия.</p>

          <p>Аналитические: ym... — только с согласия</p>

          <p>3.3. Пользователь может отказаться от предоставления телефона или VK ID — обработка ведётся только по предоставленным данным.</p>

          <p><b>4. Правовые основания и условия обработки</b></p>

          <p>4.1. Обработка ПДн осуществляется на основании Согласия субъекта ПДн (ст. 9 Закона о ПДн);</p>

          <p>4.2. Согласие даётся путём проставления отметки в чекбоксе на сайте или кнопкой в cookie-плашке.</p>

          <p><b>5. Способы и порядок обработки</b></p>

          <p>5.1. Обработка включает сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу (предоставление), обезличивание, блокирование, удаление, уничтожение ПДн.</p>

          <p>5.2. Обработка автоматизированная (с использованием сайта и сервисов) и неавтоматизированная.</p>

          <p>5.3. Передача третьим лицам: VK для авторизации (по API), Яндекс для аналитики (анонимизировано).</p>

          <p><b>6. Сроки обработки</b></p>

          <p>6.1. Для Цели 1 — до отзыва согласия или удаления учётки.</p>

          <p>6.2. Для Цели 2 — в соответствии с настройками Яндекс.Метрика (до 24 месяцев) или отзыва согласия.</p>

          <p><b>7. Меры по защите ПДн</b></p>

          <p>7.1. Оператор применяет организационные и технические меры: шифрование, доступ по ролям, резервное копирование, антивирусную защиту.</p>

          <p><b>8. Права субъекта ПДн</b></p>

          <p>8.1. Субъект имеет право на доступ, уточнение, блокирование, удаление ПДн, отзыв согласия, обжалование.</p>

          <p>8.2. Обращения направлять на email оператора. Ответ в течение 30 дней.</p>

          <p><b>9. Заключительные положения</b></p>

          <p>9.1. Политика действует бессрочно с момента публикации.</p>

          <p>9.2. Актуальная редакция размещена на сайте.</p>

          <p><b>Реквизиты оператора</b></p>

          <p>Индивидуальный предприниматель Кучугура Александр Валерьевич</p>

          <p>ОГРНИП: 309615422200057</p>

          <p>ИНН: 615421105579</p>

          <p>Адрес для обращений: kuchugura.alexander@gmail.com</p>

      </div>
    </div>
  </div>
</transition>

<transition name="fade">
  <div
    v-if="showPersonalDataModal"
    class="policy-modal-overlay"
    @click="showPersonalDataModal = false"
  >
    <div
      class="policy-modal"
      @click.stop
    >

      <button
        class="policy-modal-close"
        @click="showPersonalDataModal = false"
      >
        ×
      </button>

      <h2 class="policy-modal-title">
        Согласие на обработку персональных данных
      </h2>

      <div class="policy-modal-content">
            <p><b>СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</b></p>

            <p>Я,  _</p>

            <p>даю согласие Оператору на обработку моих персональных данных в следующих объёмах и целях.</p>

            <p><b>Цели обработки:</b></p>

            <p>Создание учётной записи и связь со мной по вопросам барной викторины (аутентификация, информирование).</p>

            <p>Аналитика посещаемости сайта (Яндекс.Метрика).</p>

            <p><b>Перечень персональных данных:</b></p>

            <p>Имя</p>

            <p>Отчество, Фамилия - опционально</p>

            <p>Номер телефона (для логина и связи)</p>

            <p>Идентификатор профиля ВКонтакте (VK ID, для логина)</p>

            <p>Cookies, IP-адрес, данные поведения (для аналитики).</p>

            <p><b>Перечень действий:</b> сбор, запись, систематизация, хранение, уточнение, извлечение, использование, обезличивание, удаление ПДн (автоматизированная и смешанная обработка).</p>

            <p><b>Третьи лица (передача):</b></p>

            <p>ВКонтакте (для авторизации по API);</p>

            <p>Яндекс (для аналитики, анонимизировано).</p>

            <p>Я ознакомлен с Политикой обработки ПДн [ссылка], понимаю, что:</p>

            <p>Обработка ведётся на основании моего согласия (ст. 9 152-ФЗ);</p>

            <p>Срок действия — до отзыва (или 24 мес. для аналитики);</p>

            <p>Могу отозвать согласие в любой момент по email оператора, обработка прекратится в 30 рабочих дней.</p>

            <p>Дата: _</p>

            <p>Электронное подтверждение: проставлением отметки «Согласен» и нажатием кнопки регистрации/принятия.</p>

            <p><b>Реквизиты оператора:</b> ИП Кучугура Александр Валерьевич, ОГРНИП 309615422200057, ИНН 615421105579, email: kuchugura.alexander@gmail.com</p>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import {useToast} from "vue-toastification";
import MyButton from "@/components/UI/MyButton.vue";
import MyInput from "@/components/UI/MyInput.vue";
import MyModal from "@/components/UI/MyModal.vue";
import VueSelect from "@/components/UI/VueSelect.vue";
import {getUnitedEventPlacesForSelect} from "@/utils/event";
import {handleError} from "@/utils/error";
import PreLoader from "@/components/UI/PreLoader.vue";

export default {
  name: "UnauthorizedRegisterOnEventForm",
  props: ['event'],
  components: {PreLoader, VueSelect, MyButton, MyInput, MyModal},
  data: ()=>{
    return{
      selectedEvent: null,
      regForm:{
        firstName: '',
        phone: '',
        teamTitle: '',
        participantCount: 1
      },
      error: null,
      codeSended: false,
      codeSendBy: null,
      validateCode: null,
      regFormResponse: null,
      isNewTeamButtonClicked: false,
      loading: false,
      isPolicyAccepted: false,
      policyError: false,
      showPolicyModal: false,
      isPersonalDataAccepted: false,
      personalDataError: false,
      showPersonalDataModal: false
    }
  },
  setup(){
    const toast = useToast()
    return {toast}
  },
  computed: {
    registrationIsOpen(){
      return ['published', 'sitting'].includes(this.event.workflow_state)
    },
    maxPlayerInTeam(){
      if (this.event && this.event.place && this.event.place.max_players_in_team){
        return this.event.place.max_players_in_team
      } else {
        return 10
      }
    },
    canSubmitForm(){
      return this.isPolicyAccepted && this.isPersonalDataAccepted
    }
  },
  mounted(){
    if (this.$store.state.user.authToken){
      this.checkRegistration()
    }
  },
  watch:{
    validateCode() {
      if (`${this.validateCode}`.length>3) this.sendValidateCode();
    },
  },
  methods:{
    submitForm(){
       const vm = this
       if(vm.loading) return
       
       // Check if both checkboxes are accepted
       if (!vm.isPolicyAccepted || !vm.isPersonalDataAccepted) {
           if (!vm.isPolicyAccepted) {
               vm.policyError = true
               setTimeout(() => { vm.policyError = false }, 1200)
           }
           if (!vm.isPersonalDataAccepted) {
               vm.personalDataError = true
               setTimeout(() => { vm.personalDataError = false }, 1200)
           }
           return
       }
       
       vm.loading = true
       vm.error = null
       vm.$logApi.log({
         logs:{
           event: 'submit form',
           phone_input_value: document.querySelector('input[data-tel-input]').value,
           form_data:{
             event: vm.selectedEvent || vm.event.id,
             phone: vm.glb.formatPhone(vm.regForm.phone),
             name: vm.regForm.firstName,
             participant_count: vm.regForm.participantCount,
             team_title: vm.regForm.teamTitle,
           }
         }
       })
       vm.$api.sendEventRegistrationForm(
           vm.selectedEvent || vm.event.id,
           {
             phone: vm.glb.formatPhone(vm.regForm.phone),
             name: vm.regForm.firstName,
             participant_count: vm.regForm.participantCount,
             team_title: vm.regForm.teamTitle,
             privacy_policy_accepted: vm.isPolicyAccepted,
             personal_data_consent: vm.isPersonalDataAccepted
           })
         .then(data=>{
           vm.$refs.finalReg.open()
           vm.regFormResponse = data
           try{
             vm.codeSended = vm.regFormResponse.send_auth_code.sent
             vm.codeSendBy = vm.regFormResponse.send_auth_code.send_by
           } catch (err){
             console.log(err)
           }
           vm.loading = false
         })
         .catch(err=>{
           handleError(err)
           vm.loading = false
         })
     },
    showFormData(){
      this.toast(JSON.stringify(this.regForm))
    },
    goToRegPage(teamId){
      this.$router.push({
        name: 'RegTeamOnEvent',
        params: {eventId: this.$route.params.eventId, teamId: teamId },
        query: {set_check: 'true'}
      })
    },
    sendValidateCode(){
      const vm = this
      vm.$api.validateAuthCode(vm.regForm.phone, vm.validateCode)
      .then(res=>{
        vm.$store.dispatch('SET_USER_TOKEN', res.token)
        vm.$store.dispatch('GET_USER_DETAILS')
        vm.goToRegPage(vm.regFormResponse.event_team.team.id)
      })
    },
    redirectToLogin(){
        const currentPath = this.$route.fullPath
        this.$router.push({ path: '/login', query: { from: currentPath } })
    },
    getUnitedEventsOptions(){
      return getUnitedEventPlacesForSelect(this.event)
    }
  }
}
</script>

<style scoped>
.policy-box {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 18px;
  padding: 16px;
  border-radius: 22px;
  background: #35358d;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.25s ease;
}

.policy-box--active {
  border-color: #b26cff;
}

.policy-box--error {
  border-color: #ff4d6d;
  box-shadow: 0 0 12px rgba(255, 77, 109, 0.5);
}

.policy-checkbox {
  min-width: 28px;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff2b9c;
  margin-top: 2px;
}

.policy-text {
  font-size: 14px;
  line-height: 1.4;
  color: #fff;
}

.policy-text a {
  color: #fff;
  text-decoration: underline;
}

/* Disabled button styling */
.my-button[disabled] {
  background: #ccc !important;
  color: #666 !important;
  cursor: not-allowed;
  opacity: 0.7;
}

.padding {
  margin-bottom: 30px;
}

.policy-box {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 18px;
  padding: 16px;
  border-radius: 22px;
  background: #35358d;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.25s ease;
}

.policy-box--active {
  border-color: #b26cff;
}

.policy-box--error {
  border-color: #ff4d6d;
  box-shadow: 0 0 12px rgba(255, 77, 109, 0.5);
}

.policy-checkbox {
  min-width: 28px;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff2b9c;
  margin-top: 2px;
}

.policy-text {
  font-size: 14px;
  line-height: 1.4;
  color: #fff;
}

.policy-text a {
  color: #fff;
  text-decoration: underline;
}
.policy-modal-overlay {
  position: fixed;
  inset: 0;

  background: rgba(0,0,0,0.55);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 9999;

  padding: 20px;
}

.policy-modal {
  position: relative;

  width: 100%;
  max-width: 420px;

  max-height: 85vh;

  background: #35358d;

  border-radius: 28px;

  padding: 28px 24px;

  box-shadow:
    0 20px 60px rgba(0,0,0,0.35);

  overflow: hidden;
}

.policy-modal-title {
  color: white;

  font-size: 28px;
  font-weight: 700;

  line-height: 1.2;

  margin-bottom: 24px;

  text-align: center;
}

.policy-modal-content {
  overflow-y: auto;

  max-height: calc(85vh - 120px);

  padding-right: 8px;

  color: white;

  font-size: 16px;
  line-height: 1.6;
}

.policy-modal-content p {
  margin-bottom: 20px;
}

.policy-modal-close {
  position: absolute;

  top: 14px;
  right: 14px;

  width: 34px;
  height: 34px;

  border: none;
  border-radius: 50%;

  background: rgba(255,255,255,0.15);

  color: white;

  font-size: 24px;

  cursor: pointer;

  transition: .2s;
}

.policy-modal-close:hover {
  background: rgba(255,255,255,0.25);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
